import { Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Data, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { CalsoftMediaWatcherService } from 'src/app/global/services/media-watcher';
import { CalsoftNavigationService } from 'src/app/global/components/navigation';

@Component({
    selector     : 'modern-layout',
    templateUrl  : './modern.component.html',
    styleUrls    : ['./modern.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModernLayoutComponent implements OnInit, OnDestroy
{

  sanitizedUrl: string = '';

  url = '';

    data: any;
    isScreenSmall: boolean;
    path:any;

    @HostBinding('class.fixed-header')
    fixedHeader: boolean;

    @HostBinding('class.fixed-footer')
    fixedFooter: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {ActivatedRoute} _activatedRoute
     * @param {CalsoftMediaWatcherService} _calsoftMediaWatcherService
     * @param {CalsoftNavigationService} _calsoftNavigationService
     * @param {Router} _router
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _calsoftMediaWatcherService: CalsoftMediaWatcherService,
        private _calsoftNavigationService: CalsoftNavigationService,
        private _router: Router
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.fixedHeader = true;
        this.fixedFooter = false;
        this.url = this._router.url || '';
            this._router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this._router.url || ''; });
    
    this.url = this._router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this._router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.url = this._router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
  }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to the resolved route data
        this._activatedRoute.data.subscribe((data: Data) => {
            this.data = data.initialData;
        });
        
        console.log(this.data);
        

        // Subscribe to media changes
        this._calsoftMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the breakpoint is 'lt-md'
                this.isScreenSmall = matchingAliases.includes('lt-md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param key
     */
    toggleNavigation(key): void
    {
        // Get the navigation
        const navigation = this._calsoftNavigationService.getComponent(key);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();
}
